webpackJsonp([118792369664667],{

/***/ 447:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/breathe-1.fb202941.jpeg";

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/breathe-2.93605f4e.jpeg";

/***/ }),

/***/ 449:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/breathe-3.2bb24b15.jpeg";

/***/ }),

/***/ 450:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/breathe-4.3a2abf47.png";

/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/breathe-web.bd77278a.jpg";

/***/ }),

/***/ 113:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/crossfader-doors.1943b73f.gif";

/***/ }),

/***/ 189:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _jake = __webpack_require__(50);
	
	var _jake2 = _interopRequireDefault(_jake);
	
	var _BackNav = __webpack_require__(15);
	
	var _BackNav2 = _interopRequireDefault(_BackNav);
	
	var _FooterRainbow = __webpack_require__(26);
	
	var _FooterRainbow2 = _interopRequireDefault(_FooterRainbow);
	
	var _breathe = __webpack_require__(447);
	
	var _breathe2 = _interopRequireDefault(_breathe);
	
	var _breathe3 = __webpack_require__(448);
	
	var _breathe4 = _interopRequireDefault(_breathe3);
	
	var _breathe5 = __webpack_require__(449);
	
	var _breathe6 = _interopRequireDefault(_breathe5);
	
	var _breathe7 = __webpack_require__(450);
	
	var _breathe8 = _interopRequireDefault(_breathe7);
	
	var _breatheWeb = __webpack_require__(452);
	
	var _breatheWeb2 = _interopRequireDefault(_breatheWeb);
	
	var _crossfaderDoors = __webpack_require__(113);
	
	var _crossfaderDoors2 = _interopRequireDefault(_crossfaderDoors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Breathe Images
	var BreatheApp = function BreatheApp() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'main work-page relative' },
	      _react2.default.createElement(_BackNav2.default, null),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'h1',
	          { className: 'huge-text col-sm-12' },
	          'Breathe'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: 'https://itunes.apple.com/us/app/breathe-daily-breathing-reminders/id976954751?ls=1&mt=8' },
	              'Breathe'
	            ),
	            ' is a friendly mindfulness app that helps you stay relaxed by sending you gentle relaxation reminders - "Breathers" - throughout your day. A free app, it was conceived by my friend Ben Erez, and designed by myself, and built by Mohammed Islam. ',
	            _react2.default.createElement(
	              'a',
	              { href: 'http://williamnewton.co/blog/breathe/' },
	              'I wrote about our process creating Breathe here.'
	            ),
	            ' It\'s available now on the ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://itunes.apple.com/us/app/breathe-daily-breathing-reminders/id976954751?ls=1&mt=8' },
	              'App Store.'
	            )
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Since I started practicing yoga, I\'ve learned the importance of the breath. Being conscious of my breathing and using it as a tool to relax and be mindful has had a hugely positive impact on my life \u2014 so that\'s the purpose of Breathe, to share this with others. '
	          )
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement('img', { className: 'img-responsive', src: _breathe2.default })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement('img', { className: 'img-responsive', src: _breathe4.default })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-4' },
	          _react2.default.createElement('img', { className: 'img-responsive', src: _breathe6.default })
	        )
	      ),
	      _react2.default.createElement('p', { className: 'lead' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement('img', { className: 'img-responsive', src: _breathe8.default })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-sm-12' },
	          _react2.default.createElement('img', { className: 'img-responsive shadow', src: _breatheWeb2.default })
	        )
	      )
	    ),
	    _react2.default.createElement(_FooterRainbow2.default, null)
	  );
	};
	
	exports.default = BreatheApp;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-breatheapp-js-62e49da6912a8283542e.js